import { TableHead } from '@/components/Datatable/TableHead';
import { SortableTableHeadersProps } from '@/type/listing.types';

export const RepairCostingTableHeaders = ({
  t,
  onSort,
}: SortableTableHeadersProps) => {
  return (
    <>
      <TableHead
        text={t('common:equipment')}
        thClassName="min-w-[200px]"
        sortable
        onSortClick={() => onSort?.('equipmentName')}
      />
      <TableHead
        text={t('common:damage')}
        thClassName="min-w-[200px]"
        sortable
        onSortClick={() => onSort?.('damageName')}
      />
      <TableHead
        text={t('common:repairService')}
        thClassName="min-w-[200px]"
        sortable
        onSortClick={() => onSort?.('repairServiceName')}
      />
      <TableHead
        text={t('common:cost')}
        thClassName="min-w-[200px]"
        sortable
        onSortClick={() => onSort?.('cost')}
      />
      <TableHead
        text={t('common:status')}
        thClassName="text-center min-w-0 w-0"
      />
      <TableHead thClassName="sticky-action-column" />
    </>
  );
};
